jQuery(document).ready(function ($) {

    let $video_id;
    let player;
    var players = [];

    $video_id = $('#home-player').data('videoid');

    function loadPlayer() {
        if (typeof (YT) == 'undefined' || typeof (YT.Player) == 'undefined') {

            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            window.onYouTubePlayerAPIReady = function () {
                jQuery('[id^="player"]').each(function (item) {
                    players[$(this).attr('id')] = onYouTubePlayer(this);
                });
            };
        }
    }

    function onYouTubePlayer(item) {
        // create the global player from the specific iframe (#video)
        let defaultPLayerVars = {rel: 0}

        if ($('.page-banner__video-container').length) {
            defaultPLayerVars = {
                rel: 0,
                mute: 1,
                controls: 0,
                modestbranding: 0,
                showinfo: 0,
                loop: 1,
                playlist: $(item).data('videoid')
            }
        }

        if ($('.page-banner__video-container').length) {
            let bannerVidInt = setInterval(() => {
                yInterval()
            }, 100);

            function yInterval() {
                if (player != undefined) {
                    onPlayerReady();
                    $('.page-banner__video-container').addClass('page-banner__video-container--less-after');
                    clearInterval(bannerVidInt);
                } else {
                }
            }
        }

        return new YT.Player($(item).attr('id'), {
            height: '390',
            width: '640',
            videoId: $(item).data('videoid'),
            playerVars: defaultPLayerVars,
        });
    }

    function onPlayerReady(clicked) {
        players[clicked].playVideo();
    }

    if ($('.section__video-wrapper').length > 0) {
        loadPlayer();
    }

    $('.section__video-overlay').on('click', function () {
        $(this).addClass('section__video-overlay--hide');
        var clicked_player = $(this).parent().find('.player');
        onPlayerReady(clicked_player.attr('id'));
    });

    $('#home-player').YTPlayer({
        fitToBackground: false,
        videoId: $video_id,
        playerVars: {
            modestbranding: 0,
            autoplay: 1,
            controls: 0,
            showinfo: 0,
            branding: 0,
            rel: 0,
            autohide: 0,
            start: 5
        },
        callback: function () {
            findPlayer();
        }
    });

    function findPlayer() {
        var homePlayerEl = $('#home-player').data('ytPlayer').player;
        homePlayerEl.playVideo();
    }

    $('.page-banner__video-container').addClass('page-banner__video-container--less-after');

});
